import type { IconNode } from '../types';

/**
 * @name flower-tulip
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgN2MtMi0zLjItNi00LTYtNHY1YzAgMy4zIDIuNyA2IDYgNnY4IiAvPgogIDxwYXRoIGQ9Ik05LjUgNC41QzEwIDMgMTIgMiAxMiAyczIgMSAyLjUgMi41IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNGMzLjMgMCA2LTIuNyA2LTZWM2MtNi4yLjktMTAuOCAxMS02IDExIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMmMtNC4yIDAtNy0xLjctNy01IDQuMiAwIDcgMS43IDcgNSIgLz4KICA8cGF0aCBkPSJNMTIgMjJjNC4yIDAgNy0xLjcgNy01LTQuMiAwLTcgMS43LTcgNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/flower-tulip
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flowerTulip: IconNode = [
  ['path', { d: 'M12 7c-2-3.2-6-4-6-4v5c0 3.3 2.7 6 6 6v8', key: '152076' }],
  ['path', { d: 'M9.5 4.5C10 3 12 2 12 2s2 1 2.5 2.5', key: 'jamjf' }],
  ['path', { d: 'M12 14c3.3 0 6-2.7 6-6V3c-6.2.9-10.8 11-6 11', key: '1kqvuy' }],
  ['path', { d: 'M12 22c-4.2 0-7-1.7-7-5 4.2 0 7 1.7 7 5', key: '1xd1ut' }],
  ['path', { d: 'M12 22c4.2 0 7-1.7 7-5-4.2 0-7 1.7-7 5', key: 'kuj2xm' }],
];

export default flowerTulip;
